import {I18n} from 'aws-amplify/utils';
import {
    Drawer,
    DrawerProps,
    ScrollArea,
} from '@mantine/core';

import {FilterForm} from '../forms/FilterForm';

export const FilterDrawer = (
    {
        recordTypes,
        opened,
        onClose,
        ...rest
    }: DrawerProps & { recordTypes: string[] },
) => (
    <Drawer
        position={'right'}
        offset={10}
        opened={opened}
        onClose={onClose}
        title={I18n.get('Filter Records')}
        padding={'xl'}
        size={'md'}
        scrollAreaComponent={ScrollArea.Autosize}
        transitionProps={{
            transition: 'slide-left',
            duration: 750,
            timingFunction: 'ease',
        }}
        {...rest}
    >
        <FilterForm
            recordTypes={recordTypes}
            onApply={onClose}
            onCancel={onClose}
        />
    </Drawer>
);
